import {h, Component, Prop, Element, Host} from "@stencil/core";
import { StringUtils } from "../../core/utils/StringUtils";
import { WebUtils } from "../../core/utils/WebUtils";

@Component({
  tag: 'snt-image',
  styleUrl: 'image-component.scss',
  shadow: false
})
export class ImageComponent {
  private emptyString = '';

  @Prop() dataSrc:string = '';
  @Prop() srcImage:string = '';
  @Prop() width: string;
  @Prop() height: string;
  @Prop() srcset:string = '';
  @Prop() imgAlt:string = '';
  @Prop() sizes:string;
  @Prop() loading:'lazy'|'eager'|'auto' = 'lazy';
  @Prop({reflect: true}) styleClasses:string = StringUtils.empty();

  @Element() element!: HTMLElement;

  render() {
    let sourceUrl: string;
    let dataSrc: string;
    sourceUrl = StringUtils.isEmpty(this.srcImage) ? this.emptyString : this.srcImage;
    dataSrc = StringUtils.isEmpty(this.dataSrc) ? this.emptyString : this.dataSrc;
    sourceUrl ||= dataSrc;

    return (
      <Host>
          <img
              class = {WebUtils.generateClasses([
                  StringUtils.isEmpty(sourceUrl) && "hidden"
              ], this.styleClasses)}
              loading={this.loading}
              alt={this.imgAlt}
              src={sourceUrl}          
          />
      </Host>
    );
  };
}
